import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import { BG_CODE_FORMAT } from '~/models/bgCode'
import { areaCodeFromTrailingDigit } from '~/pages/AdminOcctoMaster/tabs/_common/models/areaCodeFromTrailingDigit'

/**
 * BG コード末尾 1 桁 (数値) → AreaCode 変換 (AC-BG13)。
 *
 * 末尾桁 → AreaCode の写像は `areaCodeFromTrailingDigit` と共用する。
 */
export function areaCodeFromBgCodeTrailing(
  trailingDigit: number,
): AreaCode | undefined {
  return areaCodeFromTrailingDigit(trailingDigit)
}

/**
 * AC-BG02 形式の BG コードから末尾 1 桁を取り出し、対応する AreaCode を
 * 導出する。2〜4 文字目は I / O を除外し、末尾 0 (沖縄) も対象とする。
 * BgMasterFormFields の自動入力 (AC-BG13) と BgMasterFormSchema の不一致
 * 検証 (AC-BG14) の両方が本関数を共有する。
 */

export function areaCodeFromBgCode(bgCode: string): AreaCode | undefined {
  if (!BG_CODE_FORMAT.test(bgCode)) {
    return undefined
  }
  return areaCodeFromTrailingDigit(Number(bgCode[bgCode.length - 1]))
}
